export const API_OK = 'https://www.themealdb.com/api/json/v1/1/';
export const API_KO = 'no valid url';